// Jeder Query-Schlüssel beginnt mit der Mandanten-ID. RLS schützt die Daten, nicht den Cache:
// Ohne Mandant im Schlüssel zeigte ein Mandantenwechsel kurz die Daten des vorigen.
// src/test/tenant-query-keys.test.ts prüft, dass jedes useQuery einen solchen Schlüssel benutzt.

export const qk = {
  memberships: (userId: string | null) => ["memberships", userId] as const,
  departments: (tenantId: string) => [tenantId, "departments"] as const,
  employees: (tenantId: string) => [tenantId, "employees"] as const,
  templates: (tenantId: string) => [tenantId, "schedule-templates"] as const,
  assignments: (tenantId: string, employeeId: string) => [tenantId, "assignments", employeeId] as const,
  terminals: (tenantId: string) => [tenantId, "terminals"] as const,
  credentials: (tenantId: string) => [tenantId, "credentials"] as const,
  ruleSets: (tenantId: string) => [tenantId, "rule-sets"] as const,
  tenant: (tenantId: string) => [tenantId, "tenant"] as const,
  punchesOfDay: (tenantId: string, day: string) => [tenantId, "punches-day", day] as const,
  punches: (tenantId: string, employeeId: string, from: string, to: string) => [tenantId, "punches", employeeId, from, to] as const,
  workDays: (tenantId: string, employeeId: string, from: string, to: string) => [tenantId, "work-days", employeeId, from, to] as const,
  workDaysOfDay: (tenantId: string, day: string) => [tenantId, "work-days-day", day] as const,
  balances: (tenantId: string) => [tenantId, "balances"] as const,
  ledger: (tenantId: string, employeeId?: string) => [tenantId, "ledger", employeeId ?? "all"] as const,
  absences: (tenantId: string, from: string, to: string) => [tenantId, "absences", from, to] as const,
  breakReports: (tenantId: string, employeeId: string, from: string, to: string) => [tenantId, "break-reports", employeeId, from, to] as const,
  unassignedEvents: (tenantId: string) => [tenantId, "unassigned-events"] as const,
  payrollReport: (tenantId: string, month: string) => [tenantId, "payroll-report", month] as const,
  payrollPeriods: (tenantId: string) => [tenantId, "payroll-periods"] as const,
  exportProfiles: (tenantId: string) => [tenantId, "export-profiles"] as const,
  members: (tenantId: string) => [tenantId, "members"] as const,
  unifiStatus: (tenantId: string) => [tenantId, "unifi-status"] as const,
  me: (tenantId: string, userId: string) => [tenantId, "me", userId] as const,
};
